export default __webpack_public_path__ + "static/media/Book12.999360b1.pdf";